"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "A_B_TESTING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.A_B_TESTING;
  }
});
Object.defineProperty(exports, "BRAND_OPTIMIZATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BRAND_OPTIMIZATION;
  }
});
Object.defineProperty(exports, "CAMPAIGN_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CAMPAIGN_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CHANNEL_ATTRIBUTION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CHANNEL_ATTRIBUTION;
  }
});
Object.defineProperty(exports, "COLLABORATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.COLLABORATION;
  }
});
Object.defineProperty(exports, "COMPETITIVE_ANALYSIS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.COMPETITIVE_ANALYSIS;
  }
});
Object.defineProperty(exports, "CUSTOMER_ANALYTICS_SEGMENTATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMER_ANALYTICS_SEGMENTATION;
  }
});
Object.defineProperty(exports, "CUSTOMER_JOURNEY_MAPPING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMER_JOURNEY_MAPPING;
  }
});
Object.defineProperty(exports, "DATA_COLLECTION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DATA_COLLECTION;
  }
});
Object.defineProperty(exports, "DATA_VISUALIZATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DATA_VISUALIZATION;
  }
});
Object.defineProperty(exports, "INTEGRATIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INTEGRATIONS;
  }
});
Object.defineProperty(exports, "PERSONALIZATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PERSONALIZATION;
  }
});
Object.defineProperty(exports, "PREDICTIVE_ANALYTICS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PREDICTIVE_ANALYTICS;
  }
});
Object.defineProperty(exports, "REPORTS_DASHBOARDS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.REPORTS_DASHBOARDS;
  }
});
Object.defineProperty(exports, "SEO_TOOLS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SEO_TOOLS;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Analytics.js
// module id = 561
// module chunks = 209 210 211 212 213